import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Newspaper, Info, Award, Users, Trophy, LogOut, FileText, Phone, UserCheck, Radio } from "lucide-react";
import { useEffect } from "react";

const items = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/news", label: "News", icon: Newspaper },
  { to: "/admin/info", label: "Info pages", icon: Info },
  { to: "/admin/sponsors", label: "Sponsors", icon: Award },
  { to: "/admin/contacts", label: "Contacts", icon: Phone },
  { to: "/admin/site-assets", label: "Documents", icon: FileText },
  { to: "/admin/captains", label: "Captains", icon: Users },
  { to: "/admin/players", label: "Players", icon: UserCheck },
  { to: "/admin/live", label: "Live site", icon: Radio },
  { to: "/admin/championships", label: "Championships", icon: Trophy },
];

export default function AdminLayout() {
  const { user, logout, loading } = useAuth() || {};
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate("/login", { replace: true });
    else if (user.role !== "admin") navigate("/", { replace: true });
  }, [user, loading, navigate]);

  if (loading || !user || user.role !== "admin") {
    return <div className="p-10 text-muted-foreground">Loading…</div>;
  }

  return (
    <div className="min-h-screen flex bg-secondary" data-testid="admin-layout">
      <aside className="w-64 bg-[#0A0A0A] text-white flex flex-col">
        <Link to="/" className="flex items-center gap-2 p-6 border-b border-white/10">
          <div className="relative w-7 h-7">
            <div className="absolute inset-0 rounded-full othello-disc-dark border border-white/30" />
            <div className="absolute top-0 left-0 w-3.5 h-3.5 rounded-full othello-disc" />
          </div>
          <div>
            <div className="font-display font-extrabold text-sm">WOC Admin</div>
            <div className="text-[9px] uppercase tracking-[0.2em] text-white/50">Console</div>
          </div>
        </Link>
        <nav className="p-3 flex-1 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm transition-colors ${
                  isActive ? "bg-primary text-primary-foreground" : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
              data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <it.icon className="h-4 w-4" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={logout} className="flex items-center gap-3 px-3 py-2 text-sm text-white/70 hover:text-white w-full" data-testid="admin-logout">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
